export const orderSummarySelector = state => state.orderSummary;
export const isDeletingSelector = state => state.orderSummary.isDeleting;
export const currentItemQuantitySelector = state => state.orderSummary.currentItemQuantity;

